<div class="row" style="padding: 10px;">
  <div class="col-12">
    <div class="row">
      <div class="col">
        <div class="row">
          <div class="col-6">
            <app-form-group-input [label]="'insert-client-company.first-name' | translate" inputType="text" [placeHolder]="'insert-client-company.first-name' | translate" [(model)]="client.firstName" (modelChange)="usernameCreation()"></app-form-group-input>
          </div>
          <div class="col-6">
            <app-form-group-input [label]="'insert-client-company.last-name' | translate" inputType="text" [placeHolder]="'insert-client-company.last-name' | translate" [(model)]="client.lastName" (modelChange)="usernameCreation()"></app-form-group-input>
          </div>
          <div class="col-6">
            <app-form-group-input [label]="'insert-client-company.first-email' | translate" inputType="email" [placeHolder]="'insert-client-company.first-email' | translate" [(model)]="client.firstEmail"></app-form-group-input>
          </div>
          <div class="col-6">
            <app-form-group-input [label]="'insert-client-company.second-email' | translate" inputType="email" [placeHolder]="'insert-client-company.second-email' | translate" [(model)]="client.secondEmail"></app-form-group-input>
          </div>
          <div class="col-6">
            <app-form-group-input [label]="'insert-client-company.first-phone' | translate" inputType="text" [placeHolder]="'insert-client-company.first-phone' | translate" [(model)]="client.firstPhone"></app-form-group-input>
          </div>
          <div class="col-6">
            <app-form-group-input [label]="'insert-client-company.second-phone' | translate" inputType="text" [placeHolder]="'insert-client-company.second-phone' | translate" [(model)]="client.secondPhone"></app-form-group-input>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="row">
          <div class="col-12">
            <app-form-group-input [label]="'insert-client-company.username' | translate" inputType="text" [placeHolder]="'insert-client-company.username' | translate" [(model)]="client.username"></app-form-group-input>
          </div>
          <div class="col-12">
            <app-form-group-pwd-generator [label]="'insert-client-company.password' | translate" [buttonLabel]="'insert-client-company.create' | translate" pwdLength="8" [(model)]="newClientPassword" (modelChange)="onClientNewPasswordChange()"></app-form-group-pwd-generator>
          </div>
          <div class="col">
            <div class="row">
              <!-- <div class="col">
                  <app-select [label]="'insert-client-company.parent-admin' | translate" [options]="parentClientActionArray"  [(model)]="selectedParentAdminAction" (modelChange)="parentClientSelectboxChange()"></app-select>
              </div> -->
              <div class="offset-6 col">
                  <app-select [label]="'insert-client-company.company' | translate" [options]="clientCompanyActionArray" [(model)]="selectedCompanyAction" (modelChange)="companyActionSelectBoxChange()"></app-select>

              </div>
            </div>
            <div class="row">
              <div class="offset-6 col" [hidden]="hideCompanySearch">
                <app-company-select-modal [companyObject]="company" (companySelected)="onCompanySelectedEvent($event)"></app-company-select-modal>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="form-group">
          <label class="control-label">{{'insert-client-company.notes' | translate}}</label>
          <textarea class="form-control form-control-sm" rows="5" [(ngModel)]="client.notes"></textarea>
        </div>
      </div>
    </div>
  </div>
</div>
